/** Unsigned daywork tallies by project for the "Coming up" list. Any failure
 *  (no access, route not deployed yet) just means no row. Refetches when the
 *  date changes so a sheet crossing the slow threshold appears on a dashboard
 *  left open overnight. */

import { useEffect, useMemo, useState } from 'react';
import type { UnsignedDayworkTally } from '../../contract-administration/dayworkSignOff';
import { useBackgroundRead } from '../../hooks/useBackgroundRead';
import { londonDayKey, unsignedDayworksRead } from './homeComingUpReads';

const DAY_CHECK_MS = 5 * 60_000;
const NONE: Readonly<Record<string, UnsignedDayworkTally>> = {};

export function useUnsignedDayworkTallies(workspaceId: string | undefined): Readonly<Record<string, UnsignedDayworkTally>> {
  const [dayKey, setDayKey] = useState(londonDayKey);

  useEffect(() => {
    const id = window.setInterval(() => setDayKey(londonDayKey()), DAY_CHECK_MS);
    return () => window.clearInterval(id);
  }, []);

  const read = useMemo(() => (workspaceId ? unsignedDayworksRead(workspaceId) : null), [workspaceId]);
  return useBackgroundRead(workspaceId, read, { refreshKey: dayKey }) ?? NONE;
}
